export const common = {
    appName: "Sobthik",
    actions: {
        save: "সংরক্ষণ করুন",
        cancel: "বাতিল",
        confirm: "নিশ্চিত করুন",
        delete: "মুছে ফেলুন",
        close: "বন্ধ করুন",
        retry: "আবার চেষ্টা করুন",
        loadMore: "আরও দেখুন",
        back: "পেছনে",
        next: "পরবর্তী",
        previous: "পূর্ববর্তী",
        search: "খুঁজুন",
        signOut: "সাইন আউট",
        view: "দেখুন",
    },
    states: {
        loading: "লোড হচ্ছে…",
        empty: "এখানে এখনো কিছু নেই",
        error: "কিছু একটা সমস্যা হয়েছে",
        errorReference: "রেফারেন্স: {{requestId}}",
        offline: "সার্ভারে পৌঁছানো যাচ্ছে না। ইন্টারনেট সংযোগ দেখে আবার চেষ্টা করুন।",
    },
    /** SB-05: "নিজে চালিয়ে দেখুন" ডেমো ব্যবসা (docs/specs/sandbox.md)। */
    sandbox: {
        badge: "ডেমো দোকান",
        endsIn: "এই ডেমো শেষ হবে {{time}} পর",
        hoursMinutes: "{{hours}} ঘণ্টা {{minutes}} মিনিট",
        minutes: "{{minutes}} মিনিট",
        ended: "এই ডেমো শেষ হয়ে গেছে",
        signup: "আসল অ্যাকাউন্ট খুলুন — ফ্রি ট্রায়াল",
        checklistTitle: "এই পাঁচটা জিনিস চালিয়ে দেখুন",
        checklistBody: "এখানে সবকিছু আসল: একটা দোকান প্রতিদিন যে সিস্টেমে চলে, সেটাই।",
        progress: "{{total}}টার মধ্যে {{done}}টা হয়েছে",
        hide: "চেকলিস্ট লুকান",
        show: "চেকলিস্ট দেখুন",
        done: "হয়েছে",
        steps: {
            pos_sale: { title: "POS-এ একটা বিক্রি করুন", action: "POS খুলুন" },
            offline_sale: { title: "POS-এর ইন্টারনেট বন্ধ করে আবার বিক্রি করুন", action: "POS খুলুন" },
            online_order: { title: "নিজের ওয়েবসাইট থেকে কিছু অর্ডার করুন", action: "দোকান খুলুন" },
            courier_booked: { title: "একটা অর্ডারের জন্য কুরিয়ার বুক করুন", action: "অর্ডারে যান" },
            report_viewed: { title: "একটা রিপোর্ট খুলে লাভ দেখুন", action: "রিপোর্টে যান" },
        },
        enter: {
            title: "আপনার ডেমো দোকান খুলছে…",
            failed: "এই ডেমো লিংকের মেয়াদ শেষ, অথবা আগেই ব্যবহার হয়েছে।",
            again: "নতুন ডেমো শুরু করুন",
        },
    },
    theme: { label: "থিম", light: "লাইট", dark: "ডার্ক", system: "সিস্টেম" },
    language: { label: "ভাষা", en: "English", bn: "বাংলা" },
    numerals: { label: "সংখ্যা", latin: "ইংরেজি সংখ্যা (123)", bengali: "বাংলা সংখ্যা (১২৩)" },
    tenant: { label: "ব্যবসা", switch: "ব্যবসা পরিবর্তন করুন" },
    notFound: {
        title: "পেজটি পাওয়া যায়নি",
        body: "আপনি যে পেজটি খুঁজছেন সেটি নেই অথবা সরিয়ে নেওয়া হয়েছে।",
        home: "ড্যাশবোর্ডে যান",
    },
    noAccess: {
        title: "অনুমতি নেই",
        body: "এটি দেখার অনুমতি আপনার নেই। মালিক বা ম্যানেজারের সাথে যোগাযোগ করুন।",
    },
    filters: { title: "ফিল্টার", clear: "ফিল্টার মুছুন" },
    plan: {
        limitReached: "আপনার প্ল্যানে সর্বোচ্চ {{limit}}টি {{thing}} রাখা যায়। প্ল্যান আপগ্রেড করুন, অথবা জায়গা করতে একটি আর্কাইভ বা নিষ্ক্রিয় করুন।",
        featureOff: "আপনার প্ল্যানে এটি নেই। ব্যবহার করতে প্ল্যান আপগ্রেড করুন।",
        featureOffOn: "আপনার প্ল্যানে এটি নেই। {{plan}} প্ল্যানে আছে — ব্যবহার করতে আপগ্রেড করুন।",
        things: {
            locations: "লোকেশন",
            users: "স্টাফ ইউজার",
            devices: "POS ডিভাইস",
            products: "পণ্য",
            orders: "মাসিক অর্ডার",
            landingPages: "ল্যান্ডিং পেজ",
        },
    },
    form: { unsaved: "কিছু পরিবর্তন সেভ হয়নি।", saved: "সব পরিবর্তন সেভ হয়েছে।", details: "বিবরণ" },
    timeline: "টাইমলাইন",
    table: {
        columns: "কলাম",
        noResults: "কোনো ফলাফল নেই",
        selectAll: "সব সারি নির্বাচন করুন",
        selectRow: "সারি নির্বাচন করুন",
        selected_one: "{{count}}টি নির্বাচিত",
        selected_other: "{{count}}টি নির্বাচিত",
    },
    editor: {
        toolbar: "ফরম্যাটিং",
        bold: "বোল্ড",
        italic: "ইটালিক",
        underline: "আন্ডারলাইন",
        strike: "কেটে দেওয়া",
        heading2: "শিরোনাম",
        heading3: "উপশিরোনাম",
        bulletList: "বুলেট তালিকা",
        orderedList: "নম্বর তালিকা",
        quote: "উদ্ধৃতি",
        link: "লিংক",
        linkPrompt: "লিংকের ঠিকানা (https://…)। লিংক সরাতে খালি রাখুন।",
        rule: "বিভাজক রেখা",
        undo: "আগের অবস্থায় ফিরুন",
        redo: "আবার করুন",
    },
};
//# sourceMappingURL=common.js.map